import React, {useContext} from 'react'

import {invalidNPIForCreateProvider} from "../../../hooks/useMainDataManager/useMainDataManager";
import getProviderEnv from '../../../utils/getProviderEnv';
import { AppContext } from '../../containers/Main';
import Footer from "../Footer/Footer";
import {Loading} from "../Loading/Loading";
import { useStyles } from './styles';

const ErrorScreen = () => {
  const { submitForm, email, password, confirmedProvider, loading, error }: any = useContext(AppContext);
  const classes = useStyles();
  const emailError = error.includes('taken');
  // const currentEnv = getProviderEnv();
  // const currentProviderUrl = `https://${currentEnv}.doctor.com/app/login`;

  const handleResubmit = () => {
    const data = {
      acceptBaa: true,
      acceptTerms: true,
      email: email,
      partner_site_id: '',
      password: password,
    };
    if (confirmedProvider.provider_id !== invalidNPIForCreateProvider) {
      // @ts-ignore
      data.provider_id = confirmedProvider.provider_id;
    }
    submitForm(data);
  };

  const handleRedirect = () => {
    // post message so that iFrame parent can redirect to PADM
    try {
      window.parent.postMessage({ func: 'redirect' }, '*');
    } catch (_) {}
  };

  return(
    <>
      {loading ? (
        <div className={classes.errorContainer}>
          <Loading />
        </div>
      ) : (
        <div className={classes.errorContainer}>
          <p>
            {emailError ? `An account with the email ${ email } already exists.` : 'We’re sorry – we had a problem launching your account.'}
          </p>
          <p>
            {emailError ? <><button onClick={handleRedirect}>Click here to sign in.</button> You will be able to reset your password.</> :
              <button onClick={handleResubmit}>Click here to try again.</button>
            }

          </p>
        </div>
      )}
      <Footer />
    </>
  )
};

export default ErrorScreen;
